import { api } from "@/utils/api";
import { apiNl } from "@/utils/apiNl";
import { Iot } from "./Iot";
import { sanitizePathParam } from "@/utils/sanitize";
export default class DevicesRepository {
  async uploadIotBulk(data: Iot): Promise<boolean> {
    const bulkIot = await api.post(`/devices/iot`, data);
    return bulkIot.data;
  }

  async getIotByOrganization(
    organizationId: number | string,
    page = 1,
    size = 10,
    name: null | string = null
  ) {
    const oid = sanitizePathParam(organizationId);
    const response = await api.get(
      `/devices/iot/organizations/${oid}`,
      {
        params: { page, size, name },
      }
    );
    return response.data;
  }

  async getIotInformation(deviceId: number | string, loading: boolean = true) {
    let axiosMode = loading ? api : apiNl;
    const did = sanitizePathParam(deviceId);
    const response = await axiosMode.get(`/devices/${did}/info`);
    return response.data;
  }

  async getStatusOfUpload(
    iotUploadId: number | string,
    loading: boolean = true
  ) {
    let axiosMode = loading ? api : apiNl;
    const uid = sanitizePathParam(iotUploadId);
    const response = await axiosMode.get(`/devices/iot/upload/${uid}`);
    return response.data;
  }

  async postCheckedIot(iotUploadId: number | string) {
    const uid = sanitizePathParam(iotUploadId);
    const response = await api.post(
      `/devices/iot/uploads/${uid}/checked`
    );
    return response.data;
  }

  async deleteIot(iotUploadId: number | string) {
    const uid = sanitizePathParam(iotUploadId);
    const response = await api.delete(`/devices/iot/uploads/${uid}`);
    return response.data;
  }

  async getMessagesByIot(iotUploadId: number | string) {
    const uid = sanitizePathParam(iotUploadId);
    const response = await api.get(
      `devices/${uid}/messages?page=1&size=500`
    );
    return response.data;
  }
}
